export enum Gender {
  MALE,
  FEMALE,
}

export const GenderValues = {
  [Gender.MALE]: "Male",
  [Gender.FEMALE]: "Female",
};
